import { Link } from "react-router-dom";
import { useEffect, useState } from 'react'
import { Api } from '../api/baseApi'
import { useTranslation } from 'react-i18next';

const Blog = () => {
  const { i18n, t } = useTranslation();
  const isPrerender =
    typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent);

  let [blogs, setBlogs] = useState([])
  let [totalPages, setTotalPages] = useState(0)
  let [activePage, setActivePage] = useState(1)

  useEffect(() => {
    Api.get(`/api/${i18n.language}/blogs?type=Tamias`).then((res)=> {
      console.log(res);
      setBlogs(res.data.blogs)
      setTotalPages(Math.ceil(res.data.blogs.length / 6))
    })
  },[i18n.language])


  const getImageUrl = (front_files) => {
  if (Array.isArray(front_files) && front_files.length > 0) {
    const firstFile = front_files[0].file?.startsWith("/")
      ? front_files[0].file.slice(1)
      : front_files[0].file;

    return `${process.env.REACT_APP_PAGE_URL}${firstFile}`;
  }
  return "";
};
  const chagePosition= (num)=> {
    setActivePage(num)
  }

  const getBlogPath = (slug) => `/${i18n.language}/blog/${slug}`;

  
  return (
    <section className="blog padding-y-120 section-bg position-relative z-index-1 overflow-hidden">
      
      <div className="container container-two">
        <div className="row gy-4">
          {blogs.length > 0 && blogs.slice(((activePage-1) * 6), (activePage * 6)).map((item, index) => (
              <div key={index} className="col-lg-4 col-sm-6">
                <div className="post-item">
                  <div className="post-item__thumb blogs_section">
                    <div className="link blog-img_wrapper">
                      <img
                          src={getImageUrl(item.front_files)}
                          className="cover-img"
                          alt={item.typetable?.translate?.title}
                      />
                    </div>
                  </div>
                  <div className="post-item__content">
                    <div className="post-item__top flx-align">
                      <div
                          className="post-item__tag pill font-14 text-heading fw-500"
                      >
                        {item.typetable?.translate?.title}
                      </div>
                    </div>
                    <h5 className="post-item__title">
                      { item.translate?.title && <div className="custom-post__title blog_title" dangerouslySetInnerHTML={{ __html: item.translate?.title }} /> }
                    </h5>
                    <Link
                        id="readmore-button"
                        to={getBlogPath(item.slug)}
                        className="btn btn-outline-light pill fw-600"
                    >
                      {t('blogPage.reade_more')}
                    </Link>
                  </div>
                </div>
              </div>
          ))}

        </div>
        {isPrerender && blogs.length > 0 && (
          <div style={{ display: "none" }} aria-hidden="true">
            {blogs.map((item) => (
              <Link key={`prerender-${item.id || item.slug}`} to={getBlogPath(item.slug)}>
                {item.translate?.title || item.slug}
              </Link>
            ))}
          </div>
        )}
        {/* Pagination Start */}
        <div >
          <ul className="pagination common-pagination">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                <li  key={'pagination'+num} className={`page-item ${activePage === num && "active"}`} onClick={()=> chagePosition(num)}>
                  <Link className="page-link"to="#" >
                    {num}
                  </Link>
                </li>
            ))}
            {totalPages > 1 && (
                <li className="page-item" onClick={()=> chagePosition(activePage+1)}>
                  <Link className="page-link flx-align gap-2 flex-nowrap" to="#">
                    Next
                    <span className="icon line-height-1 font-20">
                  <i className="las la-arrow-right" />
                </span>
                  </Link>
                </li>
            )}
          </ul>
        </div>
        {/* Pagination End */}
      </div>
    </section>

  );
}

export default Blog;
